import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { MapPinIcon, ClockIcon, AnchorIcon, ThermometerIcon } from 'lucide-react';
type DiveCardProps = {
  dive: {
    id: string;
    location: string;
    date: string;
    depth: number;
    duration: number;
    temperature: number;
    hasPhotos: boolean;
  };
};
export const DiveCard: React.FC<DiveCardProps> = ({
  dive
}) => {
  return <Link to={`/dives/${dive.id}`} data-id="element-283">
      <Card className="hover:shadow-md transition-shadow duration-200" data-id="element-284">
        <div className="flex justify-between items-start" data-id="element-285">
          <div className="flex-1 min-w-0" data-id="element-286">
            <h3 className="font-semibold text-navy truncate" data-id="element-287">
              {dive.location}
            </h3>
            <p className="text-sm text-gray-500" data-id="element-288">{dive.date}</p>
          </div>
          {dive.hasPhotos && <Badge variant="secondary" className="ml-2 flex-shrink-0" data-id="element-289">
              Photos
            </Badge>}
        </div>
        <div className="mt-4 flex flex-wrap gap-3" data-id="element-290">
          <div className="flex items-center text-sm text-gray-600" data-id="element-291">
            <AnchorIcon size={16} className="mr-1 text-primary" data-id="element-292" />
            <span data-id="element-293">{dive.depth}m</span>
          </div>
          <div className="flex items-center text-sm text-gray-600" data-id="element-294">
            <ClockIcon size={16} className="mr-1 text-primary" data-id="element-295" />
            <span data-id="element-296">{dive.duration} min</span>
          </div>
          <div className="flex items-center text-sm text-gray-600" data-id="element-297">
            <ThermometerIcon size={16} className="mr-1 text-primary" data-id="element-298" />
            <span data-id="element-299">{dive.temperature}°C</span>
          </div>
          <div className="flex items-center text-sm text-gray-600" data-id="element-300">
            <MapPinIcon size={16} className="mr-1 text-primary" data-id="element-301" />
            <span data-id="element-302">View on map</span>
          </div>
        </div>
      </Card>
    </Link>;
};